import get from 'lodash.get';
import moment from 'moment';

// Global Selectors
// HACK: disobeys folder structure rules
import {
    selectFirstDate
    // @ts-ignore
} from 'components/DatePagination/selectors';
import {
    makeSelectQueryStringValue,
    makeSelectQueryStringNumberValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';
import { selectMyTimesheetEntries } from 'services/myTimesheetEntries/selectors';

// Global Utils
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectGroupOptions } from 'services/groups/selectors';
import { selectMyTimesheetFilteredGroups } from './components/MyTimesheetEntryForm/components/MyTimesheetGroupDropdownField/selectors';

const selectInitialValues = createDeepEqualSelector(
    [
        selectFirstDate,
        makeSelectQueryStringNumberValue('dayOfWeek'),
        selectMyTimesheetEntries,
        makeSelectQueryStringValue('myTimesheetEntryUuid'),
        selectMyTimesheetFilteredGroups,
        selectGroupOptions
    ],
    (
        firstDateState: string,
        queryStringDayOfWeekState: number | undefined,
        myTimesheetEntriesState,
        queryStringMyTimesheetEntryUuidState: string,
        myTimesheetFilteredGroupsState,
        groupOptionsState
    ) => {
        if (queryStringMyTimesheetEntryUuidState) {
            return get(
                myTimesheetEntriesState,
                queryStringMyTimesheetEntryUuidState
            );
        }

        let groupId;

        if (myTimesheetFilteredGroupsState.length === 1) {
            groupId = myTimesheetFilteredGroupsState[0].value;
        }

        const date = moment(firstDateState, 'YYYY-MM-DD')
            .add(queryStringDayOfWeekState, 'days')
            .format('YYYY-MM-DD');
        return {
            date,
            groupId
        };
    }
);

export { selectInitialValues };
